import { cn } from "@src/components/DefuseSDK/utils/cn"
import type { HostAppRoute, RenderHostAppLink } from "../types/hostAppLink"

type TradeNavigationLinksProps = {
  currentRoute: HostAppRoute
  renderHostAppLink: RenderHostAppLink
}

export function TradeNavigationLinks({
  currentRoute,
  renderHostAppLink,
}: TradeNavigationLinksProps) {
  return (
    <div className="flex flex-row items-center overflow-hidden -mx-5 -mt-5 mb-5 bg-[#2E2E2E]">
      {renderHostAppLink(
        "swap",
        <div
          className={cn(
            "flex flex-1 justify-center items-center w-full h-[68px] border-b-2 box-border text-xl font-bold leading-7 uppercase transition-colors",
            currentRoute === "swap"
              ? "border-white text-white"
              : "border-transparent text-[#B7B7B7] hover:text-white"
          )}
        >
          Swap
        </div>,
        { className: "flex-1" }
      )}

      {renderHostAppLink(
        "otc",
        <div
          className={cn(
            "flex flex-1 justify-center items-center w-full h-[68px] border-b-2 box-border text-xl font-bold leading-7 uppercase transition-colors",
            currentRoute === "otc"
              ? "border-white text-white"
              : "border-transparent text-[#B7B7B7] hover:text-white"
          )}
        >
          OTC
        </div>,
        { className: "flex-1" }
      )}
    </div>
  )
}
